import { observable, action, toJS } from "mobx";
import { WeaLocaleProvider } from "ecCom";
import WeaForm from "../../wea-form";
import WeaTableNew from "../../wea-table-new";
const { TableStore } = WeaTableNew;
const getLabel = WeaLocaleProvider.getLabel;
import Apis from "../apis/Api";
const getCondition = {
  datas: () => {
    return [
      {
        title: getLabel("81711", "基本信息"),
        defaultshow: true,
        items: [
          {
            colSpan: 2,
            conditionType: "BROWSER",
            domkey: ["operator"],
            fieldcol: 16,
            label: getLabel("99", "操作者"),
            labelcol: 8,
            browserConditionParam: {
              type: "1",
              title: getLabel("99", "操作者")
            }
          },
          {
            colSpan: 2,
            conditionType: "DATE",
            domkey: ["operateTime"],
            fieldcol: 16,
            label: getLabel("18008", "操作时间"),
            labelcol: 8,
            browserConditionParam: {
              type: "1",
              title: getLabel("18008", "操作时间")
            }
          },
          {
            colSpan: 2,
            conditionType: "BROWSER",
            domkey: ["operatorDepart"],
            fieldcol: 16,
            label: getLabel("385898", "操作者部门"),
            labelcol: 8,
            browserConditionParam: {
              type: "4",
              title: getLabel("385898", "操作者部门")
            }
          },
          {
            colSpan: 2,
            conditionType: "BROWSER",
            domkey: ["operatorSubcompany"],
            fieldcol: 16,
            label: getLabel("385899", "操作者分部"),
            labelcol: 8,
            browserConditionParam: {
              type: "164",
              title: getLabel("385899", "操作者分部")
            }
          },
          {
            colSpan: 2,
            conditionType: "INPUT",
            domkey: ["targetName"],
            fieldcol: 16,
            label: getLabel("106", "对象"),
            labelcol: 8
          }
        ]
      }
    ];
  }
};
export default class LogStore {
  @observable
  advanceShow = false;
  @observable
  form = new WeaForm();
  @observable
  tableStore = new TableStore();
  @observable
  logType;
  @observable
  logSmallType;
  @observable
  targetId;
  @observable
  detailVisible = false;
  @observable
  detailRecord = {};
  @observable
  showParams = false;
  @observable
  detailKey = `${new Date().getTime()}`;
  @observable
  detailTitle = "";
  @observable
  conditions = getCondition.datas();
  @observable
  viewdetailColums = [];
  @observable
  viewdetailDatas = [];
  @observable
  viewdetailTitles = [];
  @observable
  zhangChenFields = "";

  @action
  update = object => {
    if (Object.prototype.toString.call(object) === "[object Object]") {
      for (const key in object) {
        if (object.hasOwnProperty(key)) {
          this[key] = object[key];
        }
      }
    }
    return this;
  };

  @action
  initForm = () => {
    this.form.initFormFields(toJS(this.conditions));
    this.form.reset();
  };

  @action
  getDatas = (params = {}) => {
    let ps = { ...params, ...this.form.getFormParams() };
    if (ps.operateTime) {
      let timeArray = ps.operateTime;
      timeArray.length > 0 && (ps.operateTime = timeArray[0]);
      timeArray.length > 1 && (ps.startDate = timeArray[1]);
      timeArray.length > 2 && (ps.endDate = timeArray[2]);
    }
    ps.logType = this.logType;
    ps.logSmallType = this.logSmallType;
    if (!ps.targetId) {
      ps.targetId = this.targetId;
    }

    Apis.logView(ps).then(
      action(result => {
        this.tableStore.getDatas(result.sessionkey, 1);
      })
    );
  };

  @action
  getDetailTable() {
    this.viewdetailColums = [];
    this.viewdetailDatas = [];
    this.viewdetailTitles = [];
    this.detailRecord.mainId &&
      Apis.viewDetail({
        belongMainId: this.detailRecord.mainId,
        id: this.detailRecord.randomFieldId
      }).then(
        action(result => {
          this.viewdetailColums = result.columns;
          this.viewdetailDatas = result.data;
          this.viewdetailTitles = result.title;
          Apis.trans({ id: this.detailRecord.randomFieldId })
            .then(
              action(transRes => {
                if (transRes.status && transRes.info) {
                  this.setDetailRecord(transRes.info);
                }
                this.setDetailVisible(true);
              })
            )
            .catch(
              action(e => {
                this.setDetailVisible(true);
              })
            );
        })
      );
    !this.detailRecord.mainId &&
      Apis.trans({ id: this.detailRecord.randomFieldId })
        .then(
          action(transRes => {
            if (transRes.status && transRes.info) {
              this.setDetailRecord(transRes.info);
            }
            this.setDetailVisible(true);
          })
        )
        .catch(
          action(e => {
            this.setDetailVisible(true);
          })
        );
  }

  @action
  setDetailVisible(bool) {
    this.detailVisible = bool;
  }

  @action
  updateAdvanceShow = bool => {
    this.advanceShow = bool;
  };

  @action
  setDetailTitle(name = "") {
    this.detailTitle = name;
  }

  @action
  setDetailRecord(obj = {}) {
    this.detailRecord = { ...obj };
  }

  @action
  setShowParams(bool = false) {
    this.showParams = bool;
  }

  @action
  updateDetailkey(key = "") {
    this.detailKey = key;
  }

  @action
  zhangChenGetDatas(id) {
    Apis.getdata({ id }).then(
      action(res => {
        this.zhangChenFields = res;
      })
    );
  }

  exportCurrent = (filetype = "", filename = "") => {
    let min =
        (Number(this.tableStore.current) < 1
          ? 1
          : Number(this.tableStore.current) - 1) *
          Number(this.tableStore.pageSize) +
        1,
      max = min + Number(this.tableStore.pageSize) - 1;
    // AndyZhang 添加自定义文件名功能
    if (filename != "") {
      const form = jQuery("<form>");
      form.attr("style", "display:none");
      form.attr("target", "");
      form.attr("method", "post");
      form.attr(
        "action",
        (window.ecologyContentPath || "") + "/api/ec/dev/table/export"
      );

      const inputmin = jQuery("<input>");
      inputmin.attr("type", "hidden");
      inputmin.attr("name", "min");
      inputmin.attr("value", min);
      form.append(inputmin);

      const inputmax = jQuery("<input>");
      inputmax.attr("type", "hidden");
      inputmax.attr("name", "max");
      inputmax.attr("value", max);
      form.append(inputmax);

      const inputdataKey = jQuery("<input>");
      inputdataKey.attr("type", "hidden");
      inputdataKey.attr("name", "dataKey");
      inputdataKey.attr("value", this.dataKey);
      form.append(inputdataKey);

      const inputfiletype = jQuery("<input>");
      inputfiletype.attr("type", "hidden");
      inputfiletype.attr("name", "filetype");
      inputfiletype.attr("value", filetype);
      form.append(inputfiletype);

      const inputfilename = jQuery("<input>");
      inputfilename.attr("type", "hidden");
      inputfilename.attr("name", "filename");
      inputfilename.attr("value", filename);
      form.append(inputfilename);

      jQuery(document.body).append(form);
      form.submit();
    } else {
      Apis.tableExport({
        dataKey: this.tableStore.dataKey,
        min,
        max,
        filetype: this.filetype,
        filename: this.filename
      }).then(result => {
        window.location.href = result.url;
      });
    }
  };

  exportAll = (filetype = "", filename = "") => {
    // AndyZhang 添加自定义文件名功能
    if (filename != "") {
      const form = jQuery("<form>");
      form.attr("style", "display:none");
      form.attr("target", "");
      form.attr("method", "post");
      form.attr(
        "action",
        (window.ecologyContentPath || "") + "/api/ec/dev/table/export"
      );

      const inputdataKey = jQuery("<input>");
      inputdataKey.attr("type", "hidden");
      inputdataKey.attr("name", "dataKey");
      inputdataKey.attr("value", this.dataKey);
      form.append(inputdataKey);

      const inputfiletype = jQuery("<input>");
      inputfiletype.attr("type", "hidden");
      inputfiletype.attr("name", "filetype");
      inputfiletype.attr("value", filetype);
      form.append(inputfiletype);

      const inputfilename = jQuery("<input>");
      inputfilename.attr("type", "hidden");
      inputfilename.attr("name", "filename");
      inputfilename.attr("value", filename);
      form.append(inputfilename);

      jQuery(document.body).append(form);
      form.submit();
    } else {
      if (filename == "") {
        filetype = "";
      }
      Apis.tableExport({
        dataKey: this.tableStore.dataKey,
        filetype,
        filename
      }).then(result => {
        window.location.href = result.url;
      });
    }
  };
}



// WEBPACK FOOTER //
// ./comMobx/wea-log-view/stores/LogStore.js